<template>
  <LoaderIcon v-if="loading" />
  <div v-if="!loading">
    <p class="text-red-600" v-if="error">
      {{ typeof error === "string" ? error : 'Ошибка' }}
    </p>
    <div v-else>
      <table class="min-w-full divide-y divide-gray-200">
        <thead class="bg-gray-50">
        <tr>
          <th scope="col" class="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
            Дата
          </th>
          <th scope="col" class="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
            Сумма
          </th>
          <th scope="col" class="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
            Операция
          </th>
          <th scope="col" class="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
            Назначение
          </th>
        </tr>
        </thead>
        <tbody class="bg-white divide-y divide-gray-200">
          <tr class="hover:bg-gray-50 transition-colors" v-for="(item, index) in balanceTransactions" v-bind:key="index">
            <td class="px-3 py-2 text-left whitespace-nowrap text-sm font-medium text-gray-900">
              {{item.createdAt}}
            </td>
            <td class="px-3 py-2 text-left whitespace-nowrap text-sm " :class="item.amount > 0 ? 'text-green-800' : 'text-red-900'">
              {{item.amount}}
            </td>
            <td class="px-3 py-2 text-left whitespace-nowrap text-sm text-gray-500">
              {{item.operationType}}
<!--              CashFlow
              RefundOfFunds-->
            </td>
            <td class="px-3 py-2 whitespace-nowrap">
              {{item.purpose}}
            </td>
        </tr>
        </tbody>
      </table>
    </div>
    {{ balanceHistory }}
  </div>
</template>

<script>
import LoaderIcon from "@/components/LoaderIcon.vue";

export default {
  name: 'BalanceTransactions',
  components: {LoaderIcon},
  data() {
    return {
      balanceTransactions: null,
      error: null,
      loading: true
    }
  },
  mounted() {
    this.loadData();
  },
  computed: {
    //
  },
  methods: {
    loadData: function () {
      console.log("load balance history")

      let c = this;
      c.balanceTransactions = null;
      c.loading = true;
      c.error = false;

      this.axios.get('/api/profile/balance/transactions').then(function(response) {
        c.balanceTransactions = response.data.data;
      }).catch(function(err) {
        c.error = true;
        if (typeof err.response.data.error === "string") {
          c.error = err.response.data.error;
        }
      }).finally(function() {
        c.loading = false;
      });
    }
  }
}
</script>

<style scoped>

</style>
